<template>
  <CardContainer
    :titleChart="titleChart"
    @onCSVDownload="downloadCsv(titleChart)"
    @zoomEnabled="zoomEnabled"
    @zoomDisabled="zoomDisabled"
    :downloadId="downloadId"
    :specificSiteId="specificSiteId"
    :zoomGraphValue="zoomGraphValue"
    :downloadShow="this.nullexpected"
    class="bg-gradient-blue"
    titleTooltip="This chart shows the top 10 ‘Other’ reasons that participants have discontinued in the study. The text size is correlated with the frequency the text was recorded as an ‘Other’ reason for discontinuation. The larger the text, the more common the 'Other' reason is."
    :tooltipHtmlContent="true"
    tooltipPlacement="bottom"
    :showThreadLogoInUnexpand="this.nullexpected"
  >
    <span slot="header" class="float-right enrol-tabs"> </span>
    <vue-word-cloud style="height: 80%;width:99%;" :words="words" :font-size-ratio="5" font-family="RobotoRegular" slot="body" @update:progress="progressHandler" v-if="this.nullexpected"> </vue-word-cloud>
    <div slot="body" class="text-left min-height-0" v-if="this.nullexpected"></div>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data-downs">No Data In</div>
    </div>
  </CardContainer>
</template>

<script>
import * as d3 from "d3";
import _cloneDeep from "lodash/cloneDeep";
import CardContainer from "./word-cloud-container-dark-blue";
import { WordCloud } from "../participant-portal/insight/services/utils";
import * as dManagement from "@/services/visualization/study-completion";
import * as utils from "../../services/visualization/utils";
import { downloadCSV } from "../../services/visualization/data-management";
export default {
  props: {
    primaryColor: { type: String, default: "#d8d8d8" },
    titleChart: { type: String, default: "" },
    downloadId: { type: String, default: "" },
    zoomGraphValue: { type: String, default: "" },
    specificSiteId: [Object, Array],
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    rawData: { type: [Object, Array], default: () => {} },
    dataLoaded: { type: Boolean, default: false },
    participantsSelected: [Array, String]
  },
  components: {
    CardContainer
  },
  watch: {
    rawData: function(newVal) {
      const response = dManagement.getsiteOtherDiscontinuationReasons(newVal, this.countrySelected, this.sitesSelected);
      this.checkrawdata = newVal;
      this.setGraphDataAndConfigsff(response);
      if (Object.keys(newVal).length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    },
    sitesSelected: function(newVal) {
      const response = dManagement.getsiteOtherDiscontinuationReasons(this.rawData, this.countrySelected, newVal);
      this.setGraphDataAndConfigsff(response);
    },
    zoomGraphValue: function(newVal) {
      if (newVal) {
        this.zoomTrigger = true;
      } else {
        this.zoomTrigger = false;
      }
    },
    participantsSelected: function(newVal) {
      const localraw = this.checkrawdata;
      if (newVal.length > 0 && Object.keys(localraw).length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
    }
  },
  data() {
    return {
      palettecolors: utils.getColorPalette("gradient").split(","),
      nullexpected: null,
      dataSources: [
        {
          surveyData: []
        }
      ],
      words: null,
      color: [],
      progress: undefined,
      containerLoaded: undefined,
      checkrawdata: null
    };
  },
  methods: {
    zoomEnabled() {
      this.$emit("zoomEnabled");
    },
    zoomDisabled() {
      this.$emit("zoomDisabled");
    },
    progressHandler(e) {
      this.progress = e;
    },
    downloadCsv(titleChart) {
      setTimeout(() => {
        const header = ["Other Discontinuation Reasons", "No. of Participants"];
        const newArr = [];
        const response = dManagement.getsiteOtherDiscontinuationReasons(this.rawData, this.countrySelected, this.sitesSelected);
        response.csvData.map(item => newArr.push([item.answer, item.total]));
        downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    },
    setGraphDataAndConfigsff(response = null) {
      if (response.csvData.length > 0) {
        this.nullexpected = true;
      } else {
        this.nullexpected = false;
      }
      const dataSource = _cloneDeep(this.dataSources);
      dataSource[0].surveyData = response.csvData;
      this.dataSources = dataSource;
      this.processVisualization();
    },
    processVisualization() {
      const { words, colors } = WordCloud(this.dataSources, this.palettecolors);
      const objectWords = [];
      const tempFullArray = [];
      words.map(item => {
        tempFullArray.push(item[1]);
      });
      const minArray = Math.min(...tempFullArray);
      const maxArray = Math.max(...tempFullArray);
      const myScale = d3
        .scaleLinear()
        .domain([0, 10])
        .range([minArray, maxArray]);
      let counting = 0;
      words.forEach(word => {
        let temp = word[1];
        if (temp == minArray) {
          const maxArrayBy4 = maxArray / 4;
          temp = temp + maxArrayBy4;
        }
        if (counting < 10) {
          if (word[0].split("").length < 25) {
            objectWords.push({
              text: word[0],
              weight: myScale(temp),
              color: word[2],
              rotation: this.generateRotation()
            });
          } else {
            objectWords.push({
              text:
                word[0]
                  .split("")
                  .slice(0, 22)
                  .join("") + "...",
              weight: myScale(temp),
              color: word[2],
              rotation: 0
            });
          }
        } else {
          objectWords.push({
            text: word[0],
            weight: myScale(temp),
            color: word[2],
            rotation: this.generateRotation()
          });
        }
        counting++;
      });
      this.words = objectWords;
      this.color = colors;
    },
    generateRotation() {
      const rotations = [0, 3 / 4];
      const rotation = rotations[Math.floor(Math.random() * rotations.length)];
      return rotation;
    }
  }
};
</script>
<style lang="scss" scoped>
.full-body {
  width: 100%;
  height: 100%;
  padding-bottom: 10px;
}
.bg-gradient-blue {
  .fusioncharts-container > svg {
    background-color: unset !important;
  }
}
.no-data-downs {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: #959fa4;
  text-transform: capitalize;
  min-height: 94px;
}
</style>
